module.exports = __webpack_public_path__ + "img/multiplier.6dc1cd86.png";